export enum TipoAviso {
  GERAL = 'GERAL',
  FINANCEIRO = 'FINANCEIRO',
}

export const TIPO_AVISO_LABEL: Record<TipoAviso, string> = {
  [TipoAviso.GERAL]: 'Geral',
  [TipoAviso.FINANCEIRO]: 'Financeiro',
};

export const TIPO_AVISO_DICA: Record<TipoAviso, string> = {
  [TipoAviso.GERAL]: 'Exibido acima do header da plataforma.',
  [TipoAviso.FINANCEIRO]: 'Exibido na área de finanças.',
};

export enum StatusAviso {
  ACTIVE = 'active',
  SCHEDULED = 'scheduled',
  EXPIRED = 'expired',
  INACTIVE = 'inactive',
}

export const STATUS_AVISO_LABEL: Record<StatusAviso, string> = {
  [StatusAviso.ACTIVE]: 'Ativo',
  [StatusAviso.SCHEDULED]: 'Programado',
  [StatusAviso.EXPIRED]: 'Expirado',
  [StatusAviso.INACTIVE]: 'Inativo',
};

export enum AudienciaAviso {
  TODOS = 'TODOS',
  ESPECIFICOS = 'ESPECIFICOS',
}

export const AUDIENCIA_AVISO_LABEL: Record<AudienciaAviso, string> = {
  [AudienciaAviso.TODOS]: 'Todos os clientes',
  [AudienciaAviso.ESPECIFICOS]: 'Clientes específicos',
};

export const AUDIENCIA_AVISO_DICA: Record<AudienciaAviso, string> = {
  [AudienciaAviso.TODOS]: 'O aviso será exibido para todos os clientes da plataforma.',
  [AudienciaAviso.ESPECIFICOS]:
    'Selecione abaixo os clientes que devem visualizar este aviso.',
};

export interface AvisoDestinatarioResumo {
  id: string;
  nome: string;
  email: string;
}

export interface Aviso {
  id: string;
  titulo: string;
  tipo: TipoAviso;
  ativo: boolean;
  status: StatusAviso;
  audiencia: AudienciaAviso;
  destinatariosCount: number;
  dataInicio: string;
  dataExpiracao: string;
  createdAt: string;
  updatedAt: string;
  createdById: string | null;
  updatedById: string | null;
}

export interface AvisoDetail extends Aviso {
  mensagem: string;
  destinatariosIds: string[];
  destinatarios: AvisoDestinatarioResumo[];
}

export interface PaginatedAvisos {
  data: Aviso[];
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface AvisosFilters {
  tipo?: TipoAviso | '';
  status?: StatusAviso | '';
  dataInicioDe?: string;
  dataInicioAte?: string;
  search?: string;
}

export interface CreateAvisoPayload {
  titulo: string;
  mensagem: string;
  tipo: TipoAviso;
  dataInicio: string;
  dataExpiracao: string;
  audiencia: AudienciaAviso;
  destinatariosIds?: string[];
}

export type UpdateAvisoPayload = Partial<CreateAvisoPayload>;
